<template>
  <div>
    <b-modal :visible="showbox" @ok='saveOK' @show='openshow' @hide='showbox=false'>
      <template #modal-header>
        <h4>項目</h4>
      </template>
      <template>
        <div class='w-100'>
          <div class='d-flex align-items-center '>
            <div class='px-2' style='width:100px;'>*項目代號</div>
            <div class='flex-fill'>
              <b-input v-model='code'></b-input>
            </div>
          </div>
          <div class='d-flex align-items-center mt-2'>
            <div class='px-2' style='width:100px;'>項目年度</div>
            <div class='flex-fill'>
              <b-input v-model='year'></b-input>
            </div>
          </div>
          <div class='d-flex align-items-center mt-2'>
            <div class='px-2' style='width:100px;'>項目名稱</div>
            <div class='flex-fill'>
              <b-input v-model='name'></b-input>
            </div>
          </div>
          <div class='d-flex align-items-center mt-2'>
            <div class='px-2' style='width:100px;'>項目大分類</div>
            <div class='flex-fill'>
              <b-select v-model='class1'>
                <option value="">無分類</option>
              </b-select>
            </div>
          </div>
          <div class='d-flex align-items-center mt-2'>
            <div class='px-2' style='width:100px;'>項目小分類</div>
            <div class='flex-fill'>
              <b-select v-model='class2'>
                <option value="">無分類</option>
              </b-select>
            </div>
          </div>
          <div class='d-flex align-items-center mt-2'>
            <div class='px-2' style='width:100px;'>實體貨物</div>
            <div class='flex-fill'>
              <b-form-checkbox v-model='cargo' :value="1" :unchecked-value="0"
                :class="{'text-danger':cargo==0,'text-info':cargo==1}">
                {{cargo==0?'不出貨':'出貨'}}
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="outline-success" @click="savecheck(ok)">儲存</b-button>
        <b-button variant="outline-danger" @click="cancel()">不儲存關閉</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import ctrl from "./editEle.js"
  export default ctrl;

</script>
